import { createFileRoute } from "@tanstack/react-router";
import {
  IntersectionPage,
  buildIntersectionHead,
} from "@/components/IntersectionPage";
import { INTERSECTION_CONFIGS } from "@/lib/intersectionData";

const CONFIG = INTERSECTION_CONFIGS.find((c) => c.slug === "landscaping-seo-aurora")!;

export const Route = createFileRoute("/landscaping-seo-aurora")({
  head: () => buildIntersectionHead(CONFIG),
  component: () => <IntersectionPage config={CONFIG} />,
});
